<template>
  <transition name="modal">
    <div class="modal-mask" @click.self.stop="$emit('close')">
      <div class="modal-wrapper" @click.self.stop="$emit('close')">
        <div class="modal-container">
          <h2 class="modal-header">{{ item.name }}
            <a class="model-close-button" @click.stop="$emit('close')">
              <i class="material-icons">close</i>
            </a></h2>

          <div class="modal-body">

            <div class="button transfer"
                 v-for="target in targets"
                 v-show="item.canTransferTo(target.characterId)"
                 @click.stop="item.transfer(target)"
            >
              <img :src="target.emblemPath ">
              <span>Transfer ➡ {{ target.className }}</span>
            </div>
            <hr>
            <div class="icon equipped" v-show="item.canEquip">
              <div class="button" v-show="item.equipped" @click.stop="unEquip"><i class="material-icons">bookmark</i>
                Equipped
              </div>
              <div class="button" v-show="!item.equipped" @click.stop="equip"><i
                class="material-icons">bookmark_border</i> Unequipped
              </div>
            </div>
            <div v-show="item.key" class="icon favorite">
              <div class="button" v-show="item.favorited" @click.stop="unFavorite"><i class="material-icons">star</i>
                Favorited
              </div>
              <div class="button" v-show="!item.favorited" @click.stop="favorite"><i
                class="material-icons">star_border</i> Unfavorited
              </div>
            </div>
            <div v-show="item.canToggleLock" class="icon lock">
              <div class="button" v-show="item.isLocked" @click.stop="unLock"><i class="material-icons">lock</i> Locked
              </div>
              <div class="button" v-show="!item.isLocked" @click.stop="lock"><i class="material-icons">lock_open</i>
                Unlocked
              </div>
            </div>
            <hr>
            <div v-show="item.key">
              <div v-for="[tag, tagDefinition] in tagsDefinitions">
                <div class="tag" :class="{'enabled': item.hasTag(tag)}"
                     :style="{'background-color': tagDefinition.color}"
                     @click.stop="toggleTag(tag)">
                  <i class="fa fa-check" v-show="item.hasTag(tag)"></i>
                  {{ tag }}
                </div>
              </div>
              <div class="small">
                You can edit tags in  <a class="padded" @click="$router.push({name: 'settings'})">
                <span class="label">Settings</span>
                <i class="material-icons">settings</i>
              </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'tagsSelector',
    props: ['item'],
    data () {
      return {}
    },
    computed: {
      tagsDefinitions () {
        return Object.entries(this.$store.state.tagsDefinitions)
      },
      targets () {
        return this.$store.state.destiny.profile.characters.concat([this.$store.getters['destiny/profile/getCharacter']('VAULT')])
      }
    },
    methods: {
      toggleTag (tag) {
        this.item.toggleTag(tag)
        this.$ga.event({
          eventCategory: 'item',
          eventAction: 'toggleTag',
          eventLabel: this.item.name,
          eventValue: tag
        })
      },
      equip () {
        this.item.equip().then(() => {
          this.$ga.event({
            eventCategory: 'item',
            eventAction: 'equipItem',
            eventLabel: this.item.name,
            eventValue: 1
          })
        }).catch(error => {
          this.$store.dispatch('errors/pushError', {error: error.message})
        })
      },
      unEquip () {
        this.item.unEquip().then(() => {
          this.$ga.event({
            eventCategory: 'item',
            eventAction: 'unEquipItem',
            eventLabel: this.item.name,
            eventValue: 1
          })
        }).catch(error => {
          this.$store.dispatch('errors/pushError', {error: error.message})
        })
      },
      lock () {
        this.item.lock().then(() => {
          this.$ga.event({
            eventCategory: 'item',
            eventAction: 'lockItem',
            eventLabel: this.item.name,
            eventValue: 1
          })
        }).catch(error => {
          this.$store.dispatch('errors/pushError', {error: error.message})
        })
      },
      unLock () {
        this.item.unLock().then(() => {
          this.$ga.event({
            eventCategory: 'item',
            eventAction: 'unLockItem',
            eventLabel: this.item.name,
            eventValue: 1
          })
        }).catch(error => {
          this.$store.dispatch('errors/pushError', {error: error.message})
        })
      },
      favorite () {
        this.$store.commit('favoriteItem', {item: this.item})
        this.$ga.event({
          eventCategory: 'item',
          eventAction: 'favorite',
          eventLabel: this.item.name,
          eventValue: 1
        })
      },
      unFavorite () {
        this.$store.commit('unFavoriteItem', {item: this.item})
        this.$ga.event({
          eventCategory: 'item',
          eventAction: 'unFavorite',
          eventLabel: this.item.name,
          eventValue: 1
        })
      }
    },
    components: {}
  }
</script>

<style lang="scss">
  @import "../styles/settings";

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 480px;
    @media #{$media-phone} {
      width: 90%;
    }
    margin: 0px auto;
    background: $panel-color;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header {
    padding: 0.5rem;
    margin: 0;
    display: block;
    width: 100%;
    background: lighten($panel-color, 2%);
    border-bottom: 1px solid darken($panel-color, 2%);
  }

  .model-close-button {
    float: right;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .tag, .button, .small {
    cursor: pointer;
    padding: 0.5rem;
    text-shadow: $default-text-shadow;
    font-size: 1rem;
    transition: all .3s ease;
    color: rgba(white, 0.8);

    &.enabled {
      opacity: 1;
    }
    &:hover {
      color: rgba(white, 1);
    }
  }
  .small {
    font-size: .7rem;
    .material-icons {
      font-size: .7rem;
    }
  }

  .tag {
    opacity: 0.2;
  }

  .button {
    &:hover {
      background: $background;
    }
  }

  .transfer {
    span {
      vertical-align: middle;
      line-height: 25px;
    }
    img {
      display: inline-block;
      height: 25px;
      line-height: 25px;
      vertical-align: middle;
      margin: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// TagsSelector.vue?20949b28